// extracted by mini-css-extract-plugin
export default {"container":"AdminCreateBlog_container__YcQf4","content":"AdminCreateBlog_content__uZWBB"};